export default __webpack_public_path__ + "static/media/PFSquareSansProThin_35490.f046873c.ttf";